import { z } from "zod";

export const SignPurpose = z.enum([
  "server_ops", // v1, worker-chain
  "register_player", // legacy, api
  "first_claim_rcd", // legacy, api
  "migrate_player_begin", // legacy, api
  "wager", // legacy, api
  "shop_purchase", // legacy/v1, api — treasury co-signs atomic pay+deliver
]);
export type SignPurpose = z.infer<typeof SignPurpose>;

export const SignRequest = z.object({
  /** base64 serialized transaction message bytes */
  message: z.string(),
  opIds: z.array(z.string()),
  purpose: SignPurpose,
});
export type SignRequest = z.infer<typeof SignRequest>;

export const SignResponse = z.object({ signature: z.string() /* base58 */ });
export type SignResponse = z.infer<typeof SignResponse>;

export const SignRefusal = z.object({
  refusal: z.enum([
    "bad_program",
    "bad_fee_payer",
    "bad_version",
    "unexpected_instruction",
    "op_mismatch",
    "op_status",
    "rate_limited",
    "unauthenticated",
    "malformed",
  ]),
  detail: z.string().optional(),
});
export type SignRefusal = z.infer<typeof SignRefusal>;
